import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Spinner(props) {
  return /*#__PURE__*/_jsx("div", {
    className: "w-screen",
    "data-testid": "loading-spinner",
    children: /*#__PURE__*/_jsxs("div", {
      className: "mt-7 md:mt-28 flex flex-col gap-10 items-center",
      children: [/*#__PURE__*/_jsx(LoadingRing, {
        className: "animate-spin"
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("h4", {
          className: "mb-2 text-center",
          children: "Loading..."
        }), /*#__PURE__*/_jsx("p", {
          className: "text-sm text-grey-400 text-center",
          children: props.text
        })]
      })]
    })
  });
}
export const LoadingRing = props => /*#__PURE__*/_jsxs("svg", {
  className: props.className,
  "data-testid": "spinner-logo",
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("circle", {
    cx: "18",
    cy: "18",
    r: "16",
    stroke: "#E2E0E7",
    strokeWidth: "4"
  }), /*#__PURE__*/_jsx("path", {
    d: "M34 18C34 26.8366 26.8366 34 18 34",
    stroke: "#0E0333",
    strokeWidth: "4"
  })]
});